import React from 'react';
import PropTypes from 'prop-types';
import EditPDF from './EditPDF';
import EditImage from './EditImage';

const ItemEditFile = ({
                      mimeType,
                      ...props
                    }) => {
  const renderButton = () => {
    switch (mimeType) {
      case 'application/pdf':
        return <EditPDF {...props}  />;
      case 'image/gif':
      case 'image/jpeg':
      case 'image/tiff':
      case 'image/png':
        return <EditImage {...props}/>;
      default:
        return null;
    }
  };

  return renderButton();
};

ItemEditFile.propTypes = {
  mimeType: PropTypes.string,
};

export default ItemEditFile;
